const UNITS = ["B", "KB", "MB", "GB", "TB", "PB"] as const;

export const formatBytes = (
  bytes: number | null | undefined,
  decimals: number = 1,
): string => {
  if (bytes === null || bytes === undefined || Number.isNaN(bytes)) return "—";
  if (bytes === 0) return "0 B";

  const k = 1024;
  const i = Math.min(
    Math.floor(Math.log(Math.abs(bytes)) / Math.log(k)),
    UNITS.length - 1,
  );
  const value = bytes / Math.pow(k, i);
  const formatted = i === 0 ? value.toFixed(0) : value.toFixed(decimals);
  return `${formatted} ${UNITS[i]}`;
};
